// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"30ba703b","170":"eb3fe850","283":"e080210f","366":"34d5fde5","446":"c99947cc","488":"7bb08fb8","676":"f666f25d","898":"0fbe245c","946":"6ef70658"}[chunkId] + ".chunk.js";
};